import React, { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import api from '../api';
import AuthLayout from '../components/AuthLayout';
import FormField  from '../components/FormField';
import Button     from '../components/Button';
import Alert      from '../components/Alert';

export default function ResetPassword() {
  const [params]  = useSearchParams();
  const navigate  = useNavigate();
  const token     = params.get('token') || '';

  const [form, setForm]       = useState({ login: '', math_answer: '', image_answer: '', password: '', confirm_password: '' });
  const [mathQ, setMathQ]     = useState('');
  const [captchaImg, setCaptchaImg] = useState('');
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      if (!token) loadCaptchas();
    }, [token]);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submitRequest = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await api.post('/auth/reset-password', form);
      setSuccess(r.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Request failed');
      await loadCaptchas();
      setForm(f => ({ ...f, math_answer: '', image_answer: '' }));
    } finally {
      setLoading(false);
    }
  };

  const loadCaptchas = async () => {
    const m = await api.get('/auth/captcha/math');
    setMathQ(m.data.question);
    const i = await api.get('/auth/captcha/image');
    setCaptchaImg(i.data.image);
  };

  const submitComplete = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/reset-password/complete', { ...form, token });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  if (success) return (
    <AuthLayout title="Email sent" subtitle={success}>
      <Link to="/login" style={{ color: 'var(--accent)', fontSize: '14px' }}>Back to login</Link>
    </AuthLayout>
  );

  if (token) return (
    <AuthLayout title="New password" subtitle="Choose a new password for your account">
      <form onSubmit={submitComplete}>
        {error && <Alert>{error}</Alert>}
        <FormField label="New password" name="password" type="password" value={form.password} onChange={handle} required />
        <FormField label="Confirm password" name="confirm_password" type="password" value={form.confirm_password} onChange={handle} required />
        <Button loading={loading} type="submit" style={{ marginTop: '8px' }}>Reset password</Button>
      </form>
    </AuthLayout>
  );

  return (
    <AuthLayout title="Reset password" subtitle="Enter your username or email">
      <form onSubmit={submitRequest}>
        {error && <Alert>{error}</Alert>}
        <FormField label="Username or Email" name="login" value={form.login} onChange={handle} required />
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display:'block', fontSize:'13px', fontWeight:500, marginBottom:'6px' }}>Math: {mathQ} =</label>
          <FormField name="math_answer" type="number" value={form.math_answer} onChange={handle} required />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display:'block', fontSize:'13px', fontWeight:500, marginBottom:'6px' }}>Image captcha</label>
          {captchaImg && <img src={captchaImg} alt="captcha" style={{ display:'block', marginBottom:'8px', borderRadius:'4px', border:'1px solid var(--border)' }} />}
          <FormField name="image_answer" placeholder="Enter code" value={form.image_answer} onChange={handle} required />
        </div>
        <Button loading={loading} type="submit">Send reset link</Button>
      </form>
      <div style={{ marginTop: '20px', fontSize: '13px', color: 'var(--text-muted)' }}>
        <Link to="/login" style={{ color: 'var(--accent)', textDecoration: 'none' }}>Back to login</Link>
      </div>
    </AuthLayout>
  );
}
